/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import TableLineIcons from "../../components/TableLineIcons";
import GenericModal from "../../components/GenericModal";
import GenericSelector from "../../components/GenericSelector";
import { Button, Form, Input, InputNumber, message, Radio } from "antd";
import { Job, OutputType, ProcessType, User } from "../../JmReact";


class InOutAccounts extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {

        };

        this.id = "IN_OUT_ACCOUNTS";

        this.api = {
            get: "get_in_out_accounts",
            create: "create_in_out_accounts",
            edit: "edit_in_out_accounts",
            delete: "delete_in_out_accounts",
            check_docs: "check_docs_isset_in_out_accounts",
        }

        this.selectors = [
            { id: "IN_OUT_ACCOUNTS_GROUPS_LIST", api: "in_out_accounts_groups_list" }
        ];

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };
        this.selectors.forEach((x) => {
            if (props.data[x.id] === undefined) { props.data[x.id] = { ...props.data.genericSelector } }
        })
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(22147);
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    renderEditCol = (text, record) => {
        return (<TableLineIcons
            onEdit={() => { this.props.dataActions.genericDataStartEditing(this.id, record.key, record.index) }}
            onDelete={() => {
                this.sendAPI(this.api.check_docs, record.key, ob => {
                    if (ob.data > 0) message.error(this.getText(22163))
                    else this.props.dataActions.genericDataDeleteRow(this.id, record.key, this.props.user.companyCode, this.props.user.token, this.api.delete, this.api.get)
                })
            }}
            deleteQuetion={{ title: this.getText(22157), okText: this.getText(22158), cancelText: this.getText(22159) }}
        />)
    }

    handleCancel = () => {
        if (this.props.data[this.id].editing == 0) this.props.dataActions.genericDataCancelInlineCreate(this.id);
        else this.props.dataActions.genericDataCancelEditing(this.id);
    }

    handleOk = () => {
        this.props.dataActions.genericDataSaveEdit(
            this.id, this.props.user.companyCode, this.props.user.token,
            this.props.data[this.id].editing == 0 ? this.api.create : this.api.edit,
            this.api.get);
    }

    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
        };

        const sorter = true;
        const render = t => t;
        const typeList = { 1: gt(22155), 2: gt(22156) }
        const { editing, editedRecord } = this.props.data[this.id]
        const onChange = data => { this.props.dataActions.genericDataSetEdit(this.id, data) }

        return (<div style={divStyle}>
            <GenericTable
                {...this.props}
                id={this.id}
                getApi={this.api.get}
                title={gt(22147)}
                searchBox
                addButton={() => { this.props.dataActions.genericDataStartInlineCreate(this.id) }}
                rowsFilter={r => r.key > 0}
                columns={[
                    { title: gt(22148), key: 'tID', dataIndex: 'tID', width: "10%", sorter, render },
                    { title: gt(22149), key: 'tCode', dataIndex: 'tCode', width: "10%", sorter, render },
                    { title: gt(22150), key: 'tName', dataIndex: 'tName', width: "25%", sorter, render },
                    { title: gt(22151), key: 'tType', dataIndex: 'tType', width: "10%", sorter, render: t => typeList[t] },
                    { title: gt(22152), key: 'tVatP', dataIndex: 'tVatP', width: "10%", sorter, render },
                    { title: gt(22153), key: 'tGroupName', dataIndex: 'tGroupName', width: "25%", sorter, render },
                    { title: gt(22154), width: "10%", render: this.renderEditCol }
                ]}
            />
            <GenericModal
                visible={editing > -1}
                onCancel={this.handleCancel}
                title={gt(22160)}
                width={400}
                footer={[
                    <Button key={"back"} onClick={this.handleCancel} style={{ margin: 5 }}>{gt(22161)}</Button>,
                    <Button key={"create"} type={"primary"} onClick={this.handleOk} style={{ margin: 5 }}>{gt(22162)}</Button>,
                ]}>
                {editing > -1 ? [
                    <Form.Item label={gt(22149)}>
                        <Input value={editedRecord.tCode} onChange={e => { onChange({ tCode: e.target.value }) }} />
                    </Form.Item>,
                    <Form.Item label={gt(22150)}>
                        <Input value={editedRecord.tName} onChange={e => { onChange({ tName: e.target.value }) }} />
                    </Form.Item>,
                    <Form.Item label={gt(22151)}>
                        <Radio.Group value={editedRecord.tType} onChange={e => { onChange({ tType: e.target.value }) }} >
                            {Object.keys(typeList).map(x => (<Radio value={x}>{typeList[x]}</Radio>))}
                        </Radio.Group>
                    </Form.Item>,
                    <Form.Item label={gt(22152)}>
                        <InputNumber value={editedRecord.tVatP} onChange={e => { onChange({ tVatP: e }) }} min={0} max={100} />
                    </Form.Item>,
                    <Form.Item label={gt(22153)}>
                        <GenericSelector {...this.props} {...this.selectors[0]} value={editedRecord.tGroup} onChange={e => { onChange({ tGroup: e }) }} />
                    </Form.Item>,
                ] : ""}
            </GenericModal>
        </div>)
    }

}

export default InOutAccounts;